import { render, staticRenderFns } from "./voteDetail.vue?vue&type=template&id=42142c60&scoped=true"
import script from "./voteDetail.vue?vue&type=script&lang=js"
export * from "./voteDetail.vue?vue&type=script&lang=js"
import style0 from "./voteDetail.vue?vue&type=style&index=0&id=42142c60&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42142c60",
  null
  
)

export default component.exports